import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/erro-equip.svg'
import _imports_1 from '@/assets/images/empty_tools.svg'


const _withScopeId = n => (_pushScopeId("data-v-7f681c72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-5 pb-5 container d-flex justify-content-between" }
const _hoisted_2 = { class: "container-sections col-3" }
const _hoisted_3 = { class: "header d-flex justify-content-between align-itens-center col" }
const _hoisted_4 = { class: "m-0" }
const _hoisted_5 = { class: "content-menu card flex justify-content-center mt-3" }
const _hoisted_6 = { class: "menu-steps w-100" }
const _hoisted_7 = { class: "menu-list" }
const _hoisted_8 = { class: "menu-item" }
const _hoisted_9 = { class: "menu-item-label" }
const _hoisted_10 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_11 = { class: "menu-item-label" }
const _hoisted_12 = { class: "container-information col-10" }
const _hoisted_13 = { class: "header d-flex justify-content-between align-itens-center row" }
const _hoisted_14 = { class: "m-0 w-50" }
const _hoisted_15 = { class: "d-flex justify-content-end w-50" }
const _hoisted_16 = {
  id: "group-form",
  class: "form w-100"
}
const _hoisted_17 = { class: "mt-3 container-input" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { for: "nameGroup" }
const _hoisted_20 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_21 = {
  key: 0,
  class: "locked-note mt-3"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "lock", -1))
const _hoisted_23 = { class: "mt-3 container-input" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "status" }, "Status", -1))
const _hoisted_26 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_27 = { for: "initDate" }
const _hoisted_28 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_29 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_30 = { for: "finishDate" }
const _hoisted_31 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_32 = { class: "mt-3 container-input" }
const _hoisted_33 = { for: "checkIn" }
const _hoisted_34 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_35 = { for: "checkOut" }
const _hoisted_36 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_37 = { for: "daysWeek" }
const _hoisted_38 = { class: "row justify-content-around" }
const _hoisted_39 = ["for", "onClick"]
const _hoisted_40 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_41 = {
  key: 1,
  class: "occurrences-summary mt-2"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "event_available", -1))
const _hoisted_43 = { class: "form-group mt-4" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = {
  key: 2,
  class: "form-group"
}
const _hoisted_47 = { class: "equipaments-tags" }
const _hoisted_48 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_49 = {
  key: 3,
  class: "empty-tools"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mt-5",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_51 = { class: "mt-4" }
const _hoisted_52 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_53 = {
  key: 4,
  class: "empty-tools"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mt-5",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_55 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_ds_button = _resolveComponent("ds-button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Tag = _resolveComponent("Tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ConfirmDialog),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.groupId ? _ctx.$t("group.edit") : _ctx.$t("group.register")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", _hoisted_8, [
              _createElementVNode("a", {
                class: _normalizeClass(["menu-item-link", {
                  active:
                    _ctx.$route.name === 'AddGroup' || _ctx.$route.name === 'editGroup',
                }])
              }, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("group.fields.info")), 1)
              ], 2)
            ]),
            (_ctx.role === 'ADMIN_IOSI')
              ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["menu-item-link", { active: _ctx.$route.name === 'addGroupOrganization' }]),
                    onClick: _cache[0] || (_cache[0] = 
                  () =>
                    _ctx.$router.push({
                      name: 'addGroupOrganization',
                      params: { groupId: _ctx.groupId },
                    })
                )
                  }, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("group.fields.addOrganization")), 1)
                  ], 2)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_ds_button, {
          type: "tertiary",
          text: _ctx.$t('group.delete'),
          class: "delete-group w-75 mt-3",
          leftIcon: "delete",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmDelete(_ctx.groupId)))
        }, null, 8, ["text"])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("h4", _hoisted_14, _toDisplayString(_ctx.$t("group.fields.info")), 1),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_ds_button, {
            type: "secondary",
            leftIcon: "arrow_back",
            text: _ctx.$t('utils.back'),
            class: "me-3",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'Groups' })))
          }, null, 8, ["text"]),
          _createVNode(_component_ds_button, {
            type: "primary",
            text: _ctx.groupId ? _ctx.$t('utils.save') : _ctx.$t('utils.continue'),
            class: "me-3",
            form: "group-form",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sendGroup())),
            disabled: _ctx.disabledButton
          }, null, 8, ["text", "disabled"])
        ])
      ]),
      _createElementVNode("form", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("group.fields.name")), 1),
            _createVNode(_component_InputText, {
              id: "nameGroup",
              name: "nameGroup",
              class: _normalizeClass(["form-control", ` ${_ctx.v$.form.group.name.$error ? 'p-invalid' : ''}`]),
              modelValue: _ctx.form.group.name,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.group.name) = $event)),
              placeholder: _ctx.$t('group.fields.name'),
              required: ""
            }, null, 8, ["modelValue", "placeholder", "class"]),
            (_ctx.v$.form.group.name.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_20, _toDisplayString(_ctx.$t("utils.mandatory")), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.dateFieldsDisabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("group.lockedFields")), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode(_component_Dropdown, {
              id: "status",
              name: "status",
              class: _normalizeClass(["form-control", `${_ctx.v$.form.group.status.$error ? 'p-invalid' : ''}`]),
              options: _ctx.typeStatus,
              optionLabel: "name",
              optionValue: "code",
              placeholder: _ctx.$t('group.fields.select'),
              modelValue: _ctx.form.group.status,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.group.status) = $event)),
              required: ""
            }, {
              option: _withCtx(({ option }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(option.title_key)), 1)
              ]),
              _: 1
            }, 8, ["options", "placeholder", "modelValue", "class"]),
            (_ctx.v$.form.group.status.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_26, _toDisplayString(_ctx.$t("utils.mandatory")), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", { 'is-locked': _ctx.dateFieldsDisabled }])
          }, [
            _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("group.fields.start")), 1),
            _createVNode(_component_Calendar, {
              id: "initDate",
              name: "initDate",
              placeholder: "DD/MM/AAAA",
              class: _normalizeClass(["d-block expiration-input", ` ${
                _ctx.v$.form.group.initDate.$error || _ctx.startOutOfWeekDays
                  ? 'p-invalid'
                  : ''
              }`]),
              "date-format": "dd/mm/yy",
              "min-date": _ctx.groupId ? undefined : new Date(),
              "disabled-days": _ctx.disabledWeekDays,
              modelValue: _ctx.form.group.initDate,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.group.initDate) = $event)),
              required: "",
              disabled: _ctx.dateFieldsDisabled,
              onDateSelect: _ctx.getComputersLenght
            }, null, 8, ["min-date", "disabled-days", "modelValue", "class", "disabled", "onDateSelect"]),
            (_ctx.v$.form.group.initDate.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_28, _toDisplayString(_ctx.$t("utils.mandatory")), 1))
              : (_ctx.startOutOfWeekDays)
                ? (_openBlock(), _createElementBlock("small", _hoisted_29, _toDisplayString(_ctx.$t("group.startOutOfWeekDays", {
                  first: _ctx.occurrenceDates[0].format("DD/MM/YYYY"),
                })), 1))
                : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", { 'is-locked': _ctx.dateFieldsDisabled }])
          }, [
            _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("group.fields.finish")), 1),
            _createVNode(_component_Calendar, {
              id: "finishDate",
              name: "finishDate",
              placeholder: "DD/MM/AAAA",
              class: _normalizeClass(["d-block expiration-input", ` ${_ctx.v$.form.group.finishDate.$error ? 'p-invalid' : ''}`]),
              "date-format": "dd/mm/yy",
              minDate: 
                _ctx.form.group.initDate instanceof Date
                  ? new Date(_ctx.form.group.initDate)
                  : new Date()
              ,
              "disabled-days": _ctx.disabledWeekDays,
              modelValue: _ctx.form.group.finishDate,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.group.finishDate) = $event)),
              required: "",
              disabled: _ctx.dateFieldsDisabled,
              onDateSelect: _ctx.getComputersLenght
            }, null, 8, ["minDate", "disabled-days", "modelValue", "class", "disabled", "onDateSelect"]),
            (_ctx.v$.form.group.finishDate.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_31, _toDisplayString(_ctx.$t("utils.mandatory")), 1))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", { 'is-locked': _ctx.dateFieldsDisabled }])
          }, [
            _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t("group.fields.startHour")), 1),
            _createVNode(_component_Calendar, {
              id: "checkIn",
              name: "checkIn",
              placeholder: "HH:MM",
              timeOnly: "",
              modelValue: _ctx.form.group.calendarList[0].checkIn,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.group.calendarList[0].checkIn) = $event)),
              class: _normalizeClass(`w-100 ${
                _ctx.v$.form.group.calendarList[0].checkIn.$error ? 'p-invalid' : ''
              }`),
              required: "",
              disabled: _ctx.dateFieldsDisabled,
              onDateSelect: _ctx.getComputersLenght,
              onChange: _ctx.getComputersLenght
            }, null, 8, ["modelValue", "class", "disabled", "onDateSelect", "onChange"]),
            (_ctx.v$.form.group.calendarList[0].checkIn.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_34, _toDisplayString(_ctx.$t("utils.mandatory")), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", { 'is-locked': _ctx.dateFieldsDisabled }])
          }, [
            _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t("group.fields.finishHour")), 1),
            _createVNode(_component_Calendar, {
              id: "checkOut",
              name: "checkOut",
              placeholder: "HH:MM",
              timeOnly: "",
              modelValue: _ctx.form.group.calendarList[0].checkOut,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.group.calendarList[0].checkOut) = $event)),
              class: _normalizeClass(`w-100 ${
                _ctx.v$.form.group.calendarList[0].checkOut.$error || _ctx.errorHour
                  ? 'p-invalid'
                  : ''
              }`),
              required: "",
              disabled: 
                _ctx.dateFieldsDisabled || _ctx.form.group.calendarList[0].checkIn == ''
              ,
              onDateSelect: _ctx.getComputersLenght,
              onChange: _ctx.getComputersLenght
            }, null, 8, ["modelValue", "class", "disabled", "onDateSelect", "onChange"]),
            (_ctx.v$.form.group.calendarList[0].checkOut.$error || _ctx.errorHour)
              ? (_openBlock(), _createElementBlock("small", _hoisted_36, _toDisplayString(_ctx.v$.form.group.calendarList[0].checkOut.$error
                  ? _ctx.$t("utils.mandatory")
                  : _ctx.$t("utils.errorHour")), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group px-2", { 'is-locked': _ctx.dateFieldsDisabled }])
          }, [
            _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("group.fields.weekDays")), 1),
            _createElementVNode("div", _hoisted_38, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (day) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: day.value,
                  class: "checkdiv d-flex align-items-center flex-column"
                }, [
                  _createVNode(_component_Checkbox, {
                    modelValue: _ctx.selectedDays,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedDays) = $event)),
                    InputId: day.name,
                    id: day.name,
                    label: _ctx.navigator == 'pt-BR' ? day.label : day.enLabel,
                    name: day.name,
                    value: day.value,
                    disabled: _ctx.dateFieldsDisabled,
                    onChange: _ctx.getComputersLenght
                  }, null, 8, ["modelValue", "InputId", "id", "label", "name", "value", "disabled", "onChange"]),
                  _createElementVNode("label", {
                    class: "checkLabel",
                    for: day.name,
                    onClick: ($event: any) => (_ctx.selectDay(day.value))
                  }, _toDisplayString(day.label), 9, _hoisted_39)
                ]))
              }), 128))
            ]),
            (_ctx.noDaysSelected || _ctx.daysOutOfRange)
              ? (_openBlock(), _createElementBlock("small", _hoisted_40, _toDisplayString(_ctx.noDaysSelected
                  ? _ctx.$t("utils.mandatory")
                  : _ctx.$t("utils.errorWeekDays", { days: _ctx.missingWeekDaysLabel })), 1))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        (!_ctx.noDaysSelected && !_ctx.daysOutOfRange && _ctx.occurrencesSummary)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("span", null, _toDisplayString(_ctx.occurrencesSummary), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_43, [
          (_ctx.groupId)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_44, _toDisplayString(_ctx.$t("group.equipament")), 1))
            : (_openBlock(), _createElementBlock("h5", _hoisted_45, _toDisplayString(_ctx.$t("group.addEquipament")), 1))
        ]),
        (_ctx.computers.length > 0 || _ctx.form.group.computers.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
              _createVNode(_component_MultiSelect, {
                modelValue: _ctx.form.group.computers,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.group.computers) = $event)),
                display: "chip",
                options: _ctx.computers,
                optionLabel: "name",
                placeholder: _ctx.$t('group.fields.selectComputer'),
                maxSelectedLabels: 3,
                filter: "",
                filterPlaceholder: _ctx.$t('computer.search'),
                filterFields: ['name', 'anydeskId'],
                class: _normalizeClass(`w-full h-50 md:w-20rem mt-2 ${
              _ctx.v$.form.group.computers.$error ? 'p-invalid' : ''
            }`),
                style: {"line-height":"35px"}
              }, null, 8, ["modelValue", "options", "placeholder", "filterPlaceholder", "class"]),
              _createElementVNode("div", _hoisted_47, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.group.computers, (computer) => {
                  return (_openBlock(), _createBlock(_component_Tag, {
                    class: "me-2 mt-2 tag",
                    value: computer.name,
                    rounded: ""
                  }, null, 8, ["value"]))
                }), 256))
              ]),
              (_ctx.v$.form.group.computers.$error)
                ? (_openBlock(), _createElementBlock("small", _hoisted_48, _toDisplayString(_ctx.$t("utils.mandatory")), 1))
                : _createCommentVNode("", true)
            ]))
          : (_ctx.getComputers && _ctx.computers.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.$t("group.erroEquipament")), 1),
                (_ctx.v$.form.group.computers.$error)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_52, _toDisplayString(_ctx.$t("utils.mandatory")), 1))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                _hoisted_54,
                _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.$t("group.emptyEquipament")), 1)
              ]))
      ])
    ])
  ]))
}